module.exports = __webpack_public_path__ + "static/media/capa-comparativo-1024.2aecf096.jpg";